import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import WixOAuthCallback from './components/WixOAuthCallback';
import reportWebVitals from './reportWebVitals';
import './i18n'; // NLS support

const isOAuthCallback = window.location.pathname === '/auth/wix-oauth/callback';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isOAuthCallback ? <WixOAuthCallback /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
